import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavigationComponent } from './navigation/navigation.component';
import { LayoutModule } from '@angular/cdk/layout';
import {
  MatToolbarModule,
  MatButtonModule,
  MatSidenavModule,
  MatIconModule,
  MatListModule,
  MatInputModule,
  MatProgressBarModule,
  MatCardModule,
  MatChipsModule,
  MatAutocompleteModule,
  MatProgressSpinnerModule,
  MatSliderModule,
  MatTabsModule,
  MatStepperModule,
  MatFormFieldModule,
  MatPaginatorModule,
  MatTableModule,
  MatSortModule,
  MatSelectModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatMenuModule,
  MatCheckboxModule, 
  MatGridListModule,
  MatSlideToggleModule
} from '@angular/material';
import { SDKBrowserModule } from "../shared/sdk/index";
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LogInComponent } from './log-in/log-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FacturacionComponent } from './facturacion/facturacion.component';
import { registerLocaleData } from '@angular/common';
import localeESMX from '@angular/common/locales/es-MX';
import { FacturacionLineaComponent } from './facturacion-linea/facturacion-linea.component';
import { DescargasPdfXmlComponent } from './descargas-pdf-xml/descargas-pdf-xml.component';
import { PdfHtmlComponent } from './pdf-html/pdf-html.component';
import { FacturaGlobalComponent } from './factura-global/factura-global.component';
import { NotasCreditoComponent } from './notas-credito/notas-credito.component';
import { ComplementosPagosComponent } from './complementos-pagos/complementos-pagos.component';
import { CrearFacturaComponent } from './crear-factura/crear-factura.component';
import { LlistadoNotasCreditoComponent } from './llistado-notas-credito/llistado-notas-credito.component';
registerLocaleData(localeESMX);

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    LogInComponent,
    SignUpComponent,
    DashboardComponent,
    FacturacionComponent,
    FacturacionLineaComponent,
    DescargasPdfXmlComponent,
    PdfHtmlComponent,
    FacturaGlobalComponent,
    NotasCreditoComponent,
    ComplementosPagosComponent,
    CrearFacturaComponent,
    LlistadoNotasCreditoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatProgressBarModule,
    MatCardModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatTabsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatCheckboxModule,
    SDKBrowserModule.forRoot(),
    MatGridListModule,
    MatSlideToggleModule
  ],
  providers: [{provide: LOCALE_ID, useValue: 'es-MX' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
